import { Fragment } from '../types';

/**
 * Returns export progress (0–99) for the fragment's primary playback asset while media is generating.
 * Video fragments use `assets.video`; audio fragments use `assets.audio`.
 */
export function getFragmentMediaProgressPercent(fragment: Fragment): number | undefined {
  const asset = fragment.mediaType === 'VIDEO' ? fragment.assets.video : fragment.assets.audio;

  return asset?.progressPercent;
}
